import cookieconsent from "cookieconsent";
window.addEventListener('load', (event) => {
  const settings = {
    content : {
      header: "Este sitio web utiliza cookies",
      message: "Este sitio web utiliza cookies para garantizarle la mejor experiencia de usuario.",
      dismiss: "Entendido",
      allow: "Permitir uso de cookies",
      deny: "No permitir uso de cookies",
      link: "Leer más",
      policy: "Aviso de privacidad",
      href: "https://contyquim.com/aviso-de-privacidad",
    }
  }

  window.cookieconsent.initialise({
    container: document.getElementById('content'),
    palette: {
      popup: {
        background: "#005db9",
      },
      button: {
        background: "#ffffff",
      }
    },
    revokable: true,
    position: 'bottom-left',
    content: settings.content,
    theme: 'classic'
  });
});